import React from 'react';
import { CheckIcon, ShieldCheckIcon, ShieldIcon, ZapIcon, LockIcon, CreditCardIcon, CloudIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { PURCHASE_LINK } from '../utils/constants';
const CHECKLIST = ['6 tomos + 3 bonos', 'PDF + Editable', 'Acceso inmediato', 'Garantía 7 días'];
export function PrecioSection() {
  return <section id="precio" className="pt-10 pb-10 bg-orange-50/60 scroll-mt-10" data-id="element-153">
      <div className="max-w-lg mx-auto px-4" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-[0_0_60px_rgba(249,115,22,0.15)] border-2 border-orange-400 overflow-hidden relative" data-id="element-155">
          {/* Top Banner */}
          <div className="bg-gray-900 text-white text-center py-4 px-6" data-id="element-156">
            <h2 className="text-xl md:text-2xl font-black uppercase tracking-wide" data-id="element-157">
              MEGA PACK <span className="text-orange-400" data-id="element-158">INGLÉS</span> — Kit
              Completo
            </h2>
          </div>

          <div className="px-6 py-8 md:px-10 flex flex-col items-center" data-id="element-159">
            {/* Price */}
            <p className="text-gray-400 text-base font-bold line-through" data-id="element-160">
              $49.990
            </p>
            <div className="flex items-baseline gap-1 mt-1" data-id="element-161">
              <span className="text-5xl md:text-6xl font-black text-orange-500 tracking-tighter leading-none" data-id="element-162">
                $19.990
              </span>
              <span className="text-gray-500 text-sm font-bold" data-id="element-163">ARS</span>
            </div>

            {/* Urgency pill */}
            <div className="mt-3 mb-5 inline-flex items-center gap-1.5 bg-red-600 text-white rounded-full px-4 py-1.5" data-id="element-164">
              <ZapIcon className="w-3.5 h-3.5" data-id="element-165" />
              <span className="font-bold text-xs uppercase tracking-wide" data-id="element-166">
                Solo por hoy a este precio
              </span>
            </div>

            {/* Checklist - compact grid */}
            <div className="w-full grid grid-cols-2 gap-x-4 gap-y-2.5 mb-6" data-id="element-167">
              {CHECKLIST.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-168">
                  <CheckIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-169" />
                  <span className="text-sm font-semibold text-gray-700" data-id="element-170">
                    {item}
                  </span>
                </div>)}
            </div>

            {/* Divider */}
            <div className="w-full h-px bg-gray-100 mb-6" data-id="element-171"></div>

            {/* CTA */}
            <a href={PURCHASE_LINK} className="w-full block group" data-id="element-172">
              <div className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-black text-2xl md:text-3xl py-5 px-8 rounded-2xl text-center shadow-[0_6px_0_#c2410c] hover:shadow-[0_3px_0_#c2410c] hover:translate-y-[3px] transition-all uppercase tracking-wide" data-id="element-173">
                🛒 COMPRAR AHORA
              </div>
            </a>

            {/* Trust signals */}
            <div className="mt-5 w-full" data-id="element-174">
              <div className="flex items-center justify-center gap-2 mb-3" data-id="element-175">
                <div className="h-px flex-1 bg-gray-100" data-id="element-176"></div>
                <div className="flex items-center gap-1.5 text-green-600" data-id="element-177">
                  <ShieldCheckIcon className="w-4 h-4" data-id="element-178" />
                  <span className="text-[11px] font-bold uppercase tracking-wider" data-id="element-179">
                    Compra protegida
                  </span>
                </div>
                <div className="h-px flex-1 bg-gray-100" data-id="element-180"></div>
              </div>
              <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-181">
                <div className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5" data-id="element-182">
                  <LockIcon className="w-3.5 h-3.5 text-green-500" data-id="element-183" />
                  <span className="text-xs font-semibold text-gray-600" data-id="element-184">
                    Pago seguro
                  </span>
                </div>
                <div className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5" data-id="element-185">
                  <CreditCardIcon className="w-3.5 h-3.5 text-blue-500" data-id="element-186" />
                  <span className="text-xs font-semibold text-gray-600" data-id="element-187">
                    Mercado Pago
                  </span>
                </div>
                <div className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5" data-id="element-188">
                  <CloudIcon className="w-3.5 h-3.5 text-orange-500" data-id="element-189" />
                  <span className="text-xs font-semibold text-gray-600" data-id="element-190">
                    Envío por Drive
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}